module.exports = __webpack_public_path__ + "img/edge_nature_eolienne.d15db3ee.svg";